import { ColorEnum } from '@/constants/color'
import { Layout } from '@/features/layout/types'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface HeadingProps {
    layout: Layout
}

const Heading: FC<HeadingProps> = ({ layout }) => {
    const { t } = useTranslation()

    return layout === 'compact' ? (
        <Typography.Description size="normal" font="medium" style={{ color: ColorEnum.GRAY_900 }}>
            {t('common.overview.header')}
        </Typography.Description>
    ) : (
        <Typography.Heading variant="h4" style={{ color: ColorEnum.GRAY_900 }}>
            {t('common.overview.header')}
        </Typography.Heading>
    )
}

export default Heading
